import { useTheme, createUseStyles } from 'react-jss';
import { GetSocialStyles } from '../styles';
import { Theme } from '../../../../jss';
import { buildClassName } from '../../../../helpers';
import { GetSocialProps } from '../interfaces';
import { GetSocialState } from '../interfaces/get-social-state.interface';

export function useGetSocialEffect(props: GetSocialProps): [GetSocialState] {
  const { styleClasses } = props;

  const useStyles = createUseStyles(GetSocialStyles);
  const theme = useTheme();
  const classes = useStyles({ ...props, theme: theme as Theme });
  const className = buildClassName({ styleClasses, classes });

  const state: GetSocialState = {
    className,
  };

  return [state];
}
